import React from 'react'
import {Switch, Route} from 'react-router-dom'

import UserProfile from 'modules/User/UserProfile'
import UserChangePassword from 'modules/User/UserChangePassword'
import Customers from 'modules/Customers'
import InvitesSend from 'modules/Invites/Send'
import InvitesReceived from 'modules/Invites/Received'

const Routes = () => (
  <Switch>
    <Route exact path='/home' render={() => 'home'}/>
    <Route exact path='/home/profile' component={UserProfile}/>
    <Route exact path='/home/profile/change-password' component={UserChangePassword}/>

    <Route exact path='/home/customers-list' component={Customers}/>

    <Route exact path='/home/send-invites' component={InvitesSend}/>
    <Route exact path='/home/received-invites' component={InvitesReceived}/>
  </Switch>
)

export default Routes
